import { createStore, applyMiddleware, compose } from 'redux';

import thunkMiddleware from '../middleware/thunkMiddleware';
import clientMiddleware from '../middleware/clientMiddleware';
import createResourceMiddleware from '../middleware/resourceMiddleware';
import rootReducer from '../reducers';
import ApiClient from 'util/ApiClient';
import { isDevEnv } from 'util/browserUtils';

// NOTE: uncomment block below if you want logging during dev
/* eslint-disable no-unused-vars */
const addLoggingToDispatch = store => {
  /* eslint-enable no-unused-vars */
  /* eslint-disable no-console */
  const rawDispatch = store.dispatch;
  if (!console.group) {
    return rawDispatch;
  }

  return action => {
    console.group(action.type);
    console.log('%c prev state', 'color: gray', store.getState());
    console.log('%c action', 'color: blue', action);
    const returnValue = rawDispatch(action);
    console.log('%c next state', 'color: green', store.getState());
    console.groupEnd(action.type);
    return returnValue;
  };
  /* eslint-enable no-console */
};

export default function initStore(initialState, cookie) {
  const resources = {
    PERSISTENCE_RESOURCE: () => {},
    ADMIN_PROPERTIES_INTERVAL_RESOURCE: () => {},
  };
  const createApiClient = getState => new ApiClient(getState, cookie);

  const middleware = [
    thunkMiddleware,
    clientMiddleware(createApiClient),
    createResourceMiddleware(resources),
  ];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  );

  // if (process.env.NODE_ENV !== 'production') {
  //   store.dispatch = addLoggingToDispatch(store);
  // }

  if (isDevEnv() && module.hot) {
    // hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return {
    ...store,
  };
}



// WEBPACK FOOTER //
// ./src/state/store/storeManager.js